import { render } from "./MinifiedVocabulary.vue?vue&type=template&id=0fbccbd2&scoped=true&ts=true"
import script from "./MinifiedVocabulary.vue?vue&type=script&lang=ts"
export * from "./MinifiedVocabulary.vue?vue&type=script&lang=ts"

import "./MinifiedVocabulary.vue?vue&type=style&index=0&id=0fbccbd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbccbd2"]])

export default __exports__